import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

import mail from '@sendgrid/mail'
import RfcFacil from 'rfc-facil'
import cors from 'cors'

import { BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(RfcFacil);
Vue.use(mail);
Vue.use(cors);
Vue.use(BootstrapVueIcons);

import VueMask from 'v-mask'
Vue.use(VueMask);

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mail,
  RfcFacil,
  cors,
  render: h => h(App)
}).$mount('#app')
